import React from "react";

const WhyBecomeSeller = ({sellerData}) => {
    return (
        <section className='why-seller py-80'>
            <div className='container'>
                <div className='section-heading text-center mx-auto'>
                    {sellerData?.values?.length > 0 &&  (
                        <>
                            <h5>{sellerData?.values[0]?.attributes?.title}</h5>
                            <span className='text-gray-600'>
                                {sellerData?.values[0]?.attributes?.description}
                            </span>
                        </>
                    )}
                </div>
                <div className='row gy-4 justify-content-center'>
                    {sellerData?.values?.length > 0 && sellerData?.values.map( (value) => (
                        value?.layout === 'image_value' ?  
                            <div className='col-lg-4 col-sm-6' key={value?.id}>
                                <div className='why-seller-item text-center'>
                                    <span className='text-main-two-600 text-72 d-inline-flex'>
                                        
                                        <img
                                            src={value?.attributes?.image?.files?.large?.url}
                                            alt=''
                                            className='h-60 w-60'
                                        />
                                    </span>
                                    <h6 className='my-28'>{value?.attributes?.title}</h6>
                                    <p className='text-gray-600 max-w-392 text-lg mx-auto'>
                                        {value?.attributes?.description}
                                    </p>
                                </div>
                            </div>
                        :  null            
                    ) )} 
                </div>
            </div>
        </section>
    );
};

export default WhyBecomeSeller;
